define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var TableViewController = require('web-agent-framework/TableViewController');
    var TabsManagerViewController = require('web-agent-viewControllers/TabsManagerViewController');
    var ViewController = require('web-agent-framework/ViewController');

    var OfflineOrbViewController = ViewController.extend({

        ControllerName: "OfflineOrbViewController",

        LPViewMap: {
            offlineOrbState: ".lpview_offline_orb_state",
            offlineOrbListItems: ".lpview_offline_orb_list_items",
            offlineOrbListCounter: ".lpview_offline_orb_list_counter",
            offlineContainer: ".lpview_offline_list_container",
            offlineClearAll: ".lpview_offline_orb_list_clear_all_text"
        },

        initialize: function () {
            this.offlineOrbListCounter = 0;
            this.offlineEngagements = [];

            this.offlineTable = new TableViewController({
                rowTemplateFile: "LP_offline_list_item.html",
                lineClicked: this.lineClicked,
                dataRenderer: this.dataRenderer,
                modelData: this.offlineEngagements,
                focusedView: this.getFirstElement(this.LPViewMap.offlineOrbState),
                supportKeysNavigation: true,
                context: this
            });
            this.addViewController({viewController: this.offlineTable, target: this.LPViewMap.offlineOrbListItems});

            this.colorSchemas = {};
            this.focusedEngagements = {};
            this.flickeringTimeout = 1000;
            this.agentNoteByConversationId = {};
        },
        events: function () {
            this.bindModel({modelPath : "agent.status", callback : this.statusChanged});
            this.bindModel({modelPath : "participants.myEngagements", callback : this.handleNewEngagement});
            this.bindViewEvent({selector : this.LPViewMap.offlineOrbState, callback : this.offlineOrbClicked, DOMEvent : "click"});
            this.bindViewEvent({selector : this.LPViewMap.offlineOrbState, callback : this.hideOfflineList, DOMEvent : "blur", ignoreChildBlur : true});
            this.bindViewEvent({selector : this.LPViewMap.offlineClearAll, callback : this.offlineClearAllClicked, DOMEvent : "click"});
            this.bindViewEvent({selector : window, callback : this.resizeControl, DOMEvent : "resize", delayEvent : 10});
            this.getFirstElement(this.LPViewMap.offlineOrbState).tabIndex = 100;
            this.setCounter();
        },
        render: function () {
            this.resizeControl();
        }
    });

    OfflineOrbViewController.prototype.setCounter = function () {
        this.getFirstElement(this.LPViewMap.offlineOrbListCounter).innerHTML = this.offlineOrbListCounter;
    };

    OfflineOrbViewController.prototype.resizeControl = function () {
        if (this && this.view && this.view.parentNode) {
            var parentHeight = window.innerHeight || //IE9 and normal browsers
                (document.documentElement && document.documentElement.clientHeight ? document.documentElement.clientHeight : false )/*IE8?*/ || this.getComputedStyle(document.body, "height"); //Workaround if all else fails
            if (isNaN(parentHeight)) {
                parentHeight = Number(parentHeight.replace("px", ""));
            }
            parentHeight = parentHeight - 142;
            parentHeight = parseInt(parentHeight / 32, 10) * 32;
            parentHeight = parentHeight < 32 ? 32 : parentHeight;
            parentHeight -= 40; //Clear all bar
            if (!this.finalHeight || parentHeight !== this.finalHeight) {//Prevent unnecessary DOM changes
                this.finalHeight = parentHeight;
                this.fixMenuSize((this.offlineOrbListCounter * 32) > this.finalHeight);
                this.getFirstElement(this.LPViewMap.offlineOrbListItems).style.maxHeight = (this.finalHeight) + "px";
            }
        }
    };

    OfflineOrbViewController.prototype.fixMenuSize = function (enlarge) {
        if (this.enlarged !== enlarge) {
            this.enlarged = enlarge;
            if (enlarge) {
                this.addClass(this.LPViewMap.offlineContainer, this.offlineOrbStates.enlargedList);
            } else {
                this.removeClass(this.LPViewMap.offlineContainer, this.offlineOrbStates.enlargedList);
            }
        }
    };

    OfflineOrbViewController.prototype.offlineOrbStates = {
        hasEngagements: "has_engagements",
        active: "active_footer_orb",
        activeWithList: "has_list",
        enlargedList: "enlarged"
    };

    OfflineOrbViewController.prototype.statusChanged = function (data) {
        if (typeof data.newValue != 'undefined' && data.newValue != 'loggedIn') {
            for (var index in this.offlineEngagements) {
                if (this.offlineEngagements.hasOwnProperty(index)) {
                    this.removeOfflineVisitor(index, false);
                }
            }
            //Clear objects
            this.offlineEngagements = {};
            this.focusedEngagements = {};
            this.colorSchemas = {};

            this.offlineOrbListCounter = 0;
            this.dispose();
        }
    };
    OfflineOrbViewController.prototype.visitorDisposed = function (data) {
        if (data.newValue && data.newValue.appName) {
            this.removeOfflineVisitor(data.newValue.appName, true);
        }
    };

    OfflineOrbViewController.prototype.removeOfflineVisitor = function (visitorId, setState, unbindState) {
        var index = this.getVisitorIdIndexFromOfflineEngagements(visitorId);
        if (index != -1) {
            this.unbindVisitor(visitorId, typeof unbindState === 'boolean' ? unbindState : true);
            this.offlineEngagements.splice(this.getVisitorIdIndexFromOfflineEngagements(visitorId), 1);

            this.offlineTable.modelChanged();

            if (this.focusedEngagements.hasOwnProperty(visitorId)) {
                this.focusedEngagements[visitorId] = null;
                delete this.focusedEngagements[visitorId];
            }
            if (this.colorSchemas.hasOwnProperty(visitorId)) {
                this.colorSchemas[visitorId] = null;
                delete this.colorSchemas[visitorId];
            }

            if (this.offlineOrbListCounter > 0) {
                this.offlineOrbListCounter--;
            }
            if (setState) {
                this.setCounter();
                this.updateState();
            }
            if (this.offlineOrbListCounter === 0) {
                this.unregisterShortcut(this.shortcutType.CLOSED, this.offlineOrbClicked);
            }
        }
    };

    OfflineOrbViewController.prototype.handleNewEngagement = function (data) {
        var visitors = Object.keys(data.newValue);
        for (var visitor in visitors) {
            var visitorId = visitors[visitor];
            this.handleSingleNewEngagement(visitorId);
        }
    };

    OfflineOrbViewController.prototype.handleSingleNewEngagement = function (visitorId) {
        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
        this.bindModel({modelPath : participantPath + ".participantState.engagementState", callback : this.handleEngagementStateChanged});
    };

    OfflineOrbViewController.prototype.handleEngagementStateChanged = function (data) {
        var visitorId = data.key.split(".")[2];
        switch (data.newValue) {
            case "inactive" :
                this.addEngagementToOfflineList(visitorId);
                break;
            case "active" :
                this.removeOfflineVisitor(visitorId, true, false);
                break;
            case "completed" :
                this.addEngagementToOfflineList(visitorId);
                break;
            default :
                break;
        }
    };

    /**
     * Unbinding all events listeners for this visitor ID, from the viewEventHandler and model.
     *
     * @param visitorId
     */
    OfflineOrbViewController.prototype.unbindVisitor = function (visitorId, unbindState) {
        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
        this.unbindModel({modelPath: participantPath + ".participantTag"});
        if (unbindState) {
            this.unbindModel({modelPath: participantPath + ".participantState.engagementState"});
        }
        this.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_DISPOSED});
        this.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_FOCUSED});
        this.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_BLURRED});
    };

    OfflineOrbViewController.prototype.lineClicked = function (data) {
        var visitorId = data.rowData.visitorId;
        this.viewEventsHandler.fireEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_FOCUSED});
        this.hideOfflineList();
    };

    OfflineOrbViewController.prototype.addEngagementToOfflineList = function (visitorId) {
        this.updateCreateListItem(visitorId);
        if (this.engagementFromListFocused()) {
            this.updateState();
        } else {
            this.flickerTheOrbAndUpdateState();
        }
    };

    OfflineOrbViewController.prototype.updateCreateListItem = function (visitorId) {
        var index = this.getVisitorIdIndexFromOfflineEngagements(visitorId);
        var myChat = lpTag.WebAgent.logicController.isAcceptedEngagement(visitorId);
        var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
        var engagementState = myChat ? this.getModelParam(participantPath + '.participantState.engagementState') : '';
        var visitorName = this.getModelParam(participantPath + '.participantInfo.visitorName');
        if (index == -1) {                 // visitorId does not exist!
            var visitorSerialNumber = this.getModelParam(participantPath + '.participantInfo.visitorSerialNumber');
            var engagementStartTime = this.getModelParam(participantPath + '.participantInfo.engagementStartTime');

            var engagementType = lpTag.WebAgent.logicController.getEngagementTypeByVisitorId(visitorId);
            var isAsyncMessagingEngagement = engagementType === lpTag.WebAgent.logicController.engagementTypes.asyncMessaging;
            var lastConversationId = lpTag.WebAgent.logicController.getVisitorLastConversationId(visitorId);
            var chatId = lpTag.WebAgent.logicController.getChatIdFromVisitorId(visitorId);

            this.bindConversationNote(isAsyncMessagingEngagement, lastConversationId);

            this.bindVisitor(visitorId);

            this.offlineEngagements.push({
                visitorId: visitorId,
                name: visitorName,
                serialNumber: visitorSerialNumber ? visitorSerialNumber.toString() : -1,
                engagementStartTime: engagementStartTime,
                engagementState: engagementState,
                myChat: myChat ? '' : 'spectatedChat',
                chatId: chatId,
                lastConversationId: lastConversationId,
                engagementType: engagementType,
                isAsyncMessagingEngagement: isAsyncMessagingEngagement
            });

            this.offlineTable.modelChanged();

            if (this.offlineOrbListCounter === 0) {
                this.registerShortcut(this.shortcutType.CLOSED, this.offlineOrbClicked, {position: 'left'});
            }
            this.offlineOrbListCounter++;
            this.setCounter();
        } else {
            // updating engagementState
            var changed = false;
            var oldState = this.offlineEngagements[index].engagementState;
            if (oldState != engagementState) {
                this.offlineEngagements[index].engagementState = engagementState;
                changed = true;
            }
            // updating visitor name
            var oldName = this.offlineEngagements[index].name;
            if (oldName != visitorName) {
                this.offlineEngagements[index].name = visitorName;
                changed = true;
            }
            if (changed) {
                this.offlineTable.modelChanged();
            }
        }
    };

    OfflineOrbViewController.prototype.onConversationNoteChanged = function (data, conversationId) {
        this.agentNoteByConversationId[conversationId] = data.newValue;
        this.offlineTable.modelChanged();
    };

    OfflineOrbViewController.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return 1; // If the data is array, if no sections available, return 1
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length; // For array of arrays.
        },
        dataForSection: function (data, sectionIndex) {
            // The data will be injected to the section template.
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var rowData = data[rowIndex];
            var colorTag = '';
            var participantPath;
            var avatarImage = "";
            if (this.colorSchemas && this.colorSchemas[rowData.visitorId]) {
                colorTag = this.colorSchemas[rowData.visitorId];
            } else {
                participantPath = lpTag.WebAgent.logicController.getParticipantPath(rowData.visitorId);
                colorTag = this.getModelParam(participantPath + '.participantTag');
            }
            var focused = this.focusedVisitorId == rowData.visitorId ? "onfocus" : ""; // We use "==" instead of "===" here since the visitorId can be set both as a number and as a string so the comparator should be more flexible
            var isAsyncMessagingEngagement = rowData.isAsyncMessagingEngagement;
            var showCustomImage = "showDefaultImage";
            var agentFeedbackType = "agent_survey";
            var summaryFilled;
            var agentNote;
            if (isAsyncMessagingEngagement) {
                participantPath = lpTag.WebAgent.logicController.getParticipantPath(rowData.visitorId);
                var avatarUrl = this.getModelParam(participantPath + ".participantInfo.imageUrl");
                if (avatarUrl) {
                    showCustomImage = "showCustomImage";
                    //set avatar image with Url to return as HTML code
                    avatarImage = "<img class=\'lpview_engagement_orb_avatar_customImage customImage\' src=\'" + avatarUrl + "\'>";
                }
                agentFeedbackType = "agent_summary";
                agentNote = this.agentNoteByConversationId[rowData.lastConversationId];
                if (agentNote) {
                    summaryFilled = "summary_filled";
                } else {
                    summaryFilled = "";
                }
            }
            return {
                serialNumber: rowData.serialNumber,
                name: rowData.name,
                rowData: rowData,
                color: colorTag,
                focused: focused,
                startTime: rowData.engagementStartTime ? this.formatTime(rowData.engagementStartTime) : 0,
                engagementState: rowData.engagementState,
                myChat: rowData.myChat,
                engagementType: rowData.engagementType,
                showCustomImage: showCustomImage,
                avatarImage: avatarImage,
                agentFeedbackType: agentFeedbackType,
                summaryFilled: summaryFilled
            };
            // The data will be injected to the row template.
        }
    };

    OfflineOrbViewController.prototype.flickerTheOrbAndUpdateState = function () {
        var that = this;
        that.setListActive();
        setTimeout(function () {
            that.updateState();
        }, that.flickeringTimeout);
    };

    OfflineOrbViewController.prototype.bindConversationNote = function (isAsyncMessagingEngagement, conversationId) {
        if (isAsyncMessagingEngagement && conversationId) {
            var conversationNotePath = lpTag.WebAgent.logicController.getConversationNotePath(conversationId);
            this.bindModel({modelPath: conversationNotePath, callback: _.partialRight(this.onConversationNoteChanged, conversationId), context: this});
        }
    };

    OfflineOrbViewController.prototype.bindVisitor = function (visitorId) {
        this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_DISPOSED, callback : this.visitorDisposed});
        this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_FOCUSED, callback : this.visitorFocused});
        this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_BLURRED, callback : this.visitorBlurred});
        if (lpTag.WebAgent.logicController.isAcceptedEngagement(visitorId)) {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);
            this.bindModel({modelPath : participantPath + '.participantTag', callback : this.engagementTagChanged});
        }
    };

    OfflineOrbViewController.prototype.hideOfflineList = function () {
        if (this.menuDisplayed) {
            var offlineOrbStateElement = this.getFirstElement(this.LPViewMap.offlineOrbState);
            this.removeClass(offlineOrbStateElement, this.offlineOrbStates.activeWithList);
            this.menuDisplayed = false;
            offlineOrbStateElement = null;
            this.viewEventsHandler.fireEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.TABLE_OFFLINE_ORB_CLOSED});
        }
    };

    OfflineOrbViewController.prototype.showOfflineList = function () {
        if (!this.menuDisplayed) {
            var offlineOrbStateElement = this.getFirstElement(this.LPViewMap.offlineOrbState);
            this.addClass(offlineOrbStateElement, this.offlineOrbStates.activeWithList);
            this.menuDisplayed = true;
            offlineOrbStateElement = null;
            this.offlineTable.clearSelection();
            this.getFirstElement(this.LPViewMap.offlineOrbState).focus(); // TODO: might need to be changed later to focus on the offline engagement list for navigation
            this.viewEventsHandler.fireEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.TABLE_OFFLINE_ORB_OPENED});
        }
    };

    OfflineOrbViewController.prototype.offlineOrbClicked = function () {
        if (this.offlineOrbListCounter > 0) {
            if (this.menuDisplayed) {
                this.hideOfflineList();
            } else {
                this.showOfflineList();
            }
        }
    };

    OfflineOrbViewController.prototype.offlineClearAllClicked = function () {
        if (this.offlineEngagements.length > 0) {
            var engagement = _.find(this.offlineEngagements, _shouldEngagementBeCleared);
            if (engagement) {
                this.hideEngagement(engagement);
                setTimeout(this.offlineClearAllClicked.bind(this), 0);
            }
        }

        /**
         * Returns true if the engagement should be cleared. This happens if the engagement is completed (agent survey is
         * submitted or there's no agent survey) OR if the chat is spectated OR if it's a messaging conversation.
         * @param engagement - The engagement.
         * @returns {boolean} True if the engagement should be cleared.
         * @private
         */
        function _shouldEngagementBeCleared(engagement) {
            return engagement.engagementState === lpTag.WebAgent.logicController.engagementStates.completed ||
                engagement.myChat !== '' ||
                !!engagement.isAsyncMessagingEngagement;
        }
    };

    OfflineOrbViewController.prototype.hideEngagement = function (engagement) {
        this.modelController.setAgentTyping({
            chatId: engagement.chatId,
            typing: false
        });
        lpTag.WebAgent.logicController.disposeParticipant(engagement.visitorId);
        this.viewEventsHandler.fireEvent({
            appName: engagement.visitorId,
            UIEvent: this.eventType.VISITOR_DISPOSED,
            eventData: {visitorId: engagement.visitorId},
            deleteOnFire: true
        });
    };

    OfflineOrbViewController.prototype.visitorFocused = function (data) {
        if (data.newValue) {
            this.focusedVisitorId = data.newValue.appName;
            this.focusedEngagements[data.newValue.appName] = true;
            this.offlineTable.modelChanged();
            this.updateState();
        }
    };

    OfflineOrbViewController.prototype.visitorBlurred = function (data) {
        if (data.newValue && data.newValue.appName === this.focusedVisitorId) {
            this.focusedVisitorId = null;
            this.focusedEngagements[data.newValue.appName] = false;
            this.offlineTable.modelChanged();
            this.updateState();
        }
    };

    /**
     * Updating the Offline state, if nothing is on the list, removing all classes.
     */
    OfflineOrbViewController.prototype.updateState = function () {
        if (this.offlineOrbListCounter === 0) {
            this.setListInactive();
        } else {
            if (this.engagementFromListFocused()) {
                this.setListActive();
            } else {
                this.setListHasEngagements();
            }
        }
    };

    OfflineOrbViewController.prototype.engagementFromListFocused = function () {
        var active = false;
        for (var index in this.focusedEngagements) {
            if (!active && this.focusedEngagements.hasOwnProperty(index) && this.focusedEngagements[index] === true) {
                active = true;
            }
        }
        return active;
    };

    OfflineOrbViewController.prototype.setListActive = function () {
        var offlineOrbStateElement = this.getFirstElement(this.LPViewMap.offlineOrbState);
        this.removeClass(offlineOrbStateElement, this.offlineOrbStates.hasEngagements);
        this.addClass(offlineOrbStateElement, this.offlineOrbStates.active);
        offlineOrbStateElement = null;
    };

    OfflineOrbViewController.prototype.setListHasEngagements = function () {
        var offlineOrbStateElement = this.getFirstElement(this.LPViewMap.offlineOrbState);
        this.removeClass(offlineOrbStateElement, this.offlineOrbStates.active);
        this.addClass(offlineOrbStateElement, this.offlineOrbStates.hasEngagements);
        offlineOrbStateElement = null;
    };

    OfflineOrbViewController.prototype.setListInactive = function () {
        this.removeClass(this.LPViewMap.offlineOrbState, [this.offlineOrbStates.hasEngagements, this.offlineOrbStates.active, this.offlineOrbStates.activeWithList]);
    };

    OfflineOrbViewController.prototype.showOfflineEngagement = function (event) {
        if (event.eventSelector) {
            var visitorId = event.eventSelector.split("_")[2];
            this.viewEventsHandler.fireEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_FOCUSED});
            this.hideOfflineList();
            this.stopPropagation(event);
            this.touchSession();
        }
    };

    OfflineOrbViewController.prototype.engagementTagChanged = function (data) {
        var visitorId = data.key.split(".")[2];
        if (!data.newValue) {
            return;
        }
        this.colorSchemas[visitorId] = data.newValue;
    };

    OfflineOrbViewController.prototype.getVisitorIdIndexFromOfflineEngagements = function (visitorId) {
        for (var i = 0; i < this.offlineEngagements.length; i++) {
            if (this.offlineEngagements[i].visitorId == visitorId) {
                return i;
            }
        }
        return -1;
    };

    return OfflineOrbViewController;

});
